import { Autocomplete, TextField } from "@mui/material";

import LocationInput from "./map.jsx";

const Address = ({ data, setData, counteries, cities, states, regions }) => {
  return (
    <div>
      <div className="grid md:grid-cols-4 gap-3">
        <Autocomplete
          value={counteries?.find((item) => item.id === data.countryId)}
          onChange={(event, newValue) => {
            setData({
              ...data,
              countryId: newValue?.id,
              provinceId: null,
              cityId: null,
              regionId: null,
            });
          }}
          inputValue={
            counteries?.find((item) => item.id === data.countryId)?.title || ""
          }
          getOptionLabel={(option) => option?.title}
          id="controllable-states-demo"
          options={counteries || []}
          renderInput={(params) => (
            <TextField
              focused
              {...params}
              sx={{
                input: {
                  paddingRight: "20px !important",
                },
              }}
              label={"    انتخاب کشور"}
            />
          )}
        />
        <Autocomplete
          value={states?.find((item) => item.id === data.provinceId)}
          onChange={(event, newValue) => {
            setData({
              ...data,
              provinceId: newValue?.id,
              cityId: null,
              regionId: null,
            });
          }}
          inputValue={
            states?.find((item) => item.id === data.provinceId)?.title || ""
          }
          getOptionLabel={(option) => option?.title}
          id="controllable-states-demo"
          options={states || []}
          renderInput={(params) => (
            <TextField
              focused
              {...params}
              sx={{
                input: {
                  paddingRight: "20px !important",
                },
              }}
              label={"    انتخاب استان"}
            />
          )}
        />
        <Autocomplete
          value={cities?.find((item) => item.id === data.cityId)}
          onChange={(event, newValue) => {
            setData({ ...data, cityId: newValue?.id, regionId: null });
          }}
          inputValue={
            cities?.find((item) => item.id === data.cityId)?.title || ""
          }
          getOptionLabel={(option) => option?.title}
          id="controllable-states-demo"
          options={cities || []}
          renderInput={(params) => (
            <TextField
              focused
              {...params}
              sx={{
                input: {
                  paddingRight: "20px !important",
                },
              }}
              label={"    انتخاب شهر"}
            />
          )}
        />
        <Autocomplete
          value={regions?.find((item) => item.id === data.regionId)}
          onChange={(event, newValue) => {
            setData({ ...data, regionId: newValue?.id });
          }}
          inputValue={
            regions?.find((item) => item.id === data.regionId)?.title || ""
          }
          getOptionLabel={(option) => option?.title}
          id="controllable-states-demo"
          options={regions || []}
          renderInput={(params) => (
            <TextField
              focused
              {...params}
              sx={{
                input: {
                  paddingRight: "20px !important",
                },
              }}
              label={"    انتخاب منطقه"}
            />
          )}
        />
      </div>
      <LocationInput setData={setData} data={data} />
    </div>
  );
};

export default Address;
